import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    color?: string;
    size?: number;
}
const RefreshButtonIcon = (props: Props): JSX.Element => (
    <svg
        width={props.size ?? 24}
        height={props.size ?? 24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.25 6.71137C17.7778 5.033 15.3851 3.25 12.0002 3.25C7.17875 3.25 3.25048 6.94302 3.25048 11.5792C3.25048 11.9934 3.58627 12.3292 4.00048 12.3292C4.41469 12.3292 4.75048 11.9934 4.75048 11.5792C4.75048 7.84363 7.9331 4.75 12.0002 4.75C15.2155 4.75 17.4067 6.69989 18.6148 8.3028H16.4446C16.0303 8.3028 15.6946 8.63859 15.6946 9.0528C15.6946 9.46702 16.0303 9.8028 16.4446 9.8028H20C20.4142 9.8028 20.75 9.46702 20.75 9.0528L20.75 5.68427C20.75 5.27006 20.4142 4.93427 20 4.93427C19.5858 4.93427 19.25 5.27006 19.25 5.68427L19.25 6.71137ZM19.9995 11.6708C19.5853 11.6708 19.2495 12.0066 19.2495 12.4208C19.2495 16.1564 16.0669 19.25 11.9998 19.25C8.78453 19.25 6.59329 17.3001 5.38522 15.6972H7.55545C7.96966 15.6972 8.30545 15.3614 8.30545 14.9472C8.30545 14.533 7.96966 14.1972 7.55545 14.1972H4C3.58579 14.1972 3.25 14.533 3.25 14.9472V18.3157C3.25 18.7299 3.58579 19.0657 4 19.0657C4.41422 19.0657 4.75 18.7299 4.75 18.3157V17.2886C6.22225 18.967 8.61494 20.75 11.9998 20.75C16.8212 20.75 20.7495 17.057 20.7495 12.4208C20.7495 12.0066 20.4137 11.6708 19.9995 11.6708Z"
            fill={props.color ?? resolveColor("--theme-primary")}
        />
    </svg>
);

export default RefreshButtonIcon;
